import firebase from 'firebase/app';
import 'firebase/functions';

const app = firebase.app();
export const functions = app.functions('europe-west3');
